import { connect } from 'react-redux';
import { DISTANCE_UNITS_MAP, maxDistanceForCountry, removeCurrentPage, removeURLParameters } from '../../../app/helpers';
import { get as getI18n, getCountry } from '../../../modules/I18n';
import { getPoint, getMaxDistance, getIntervals, getDisplayLocation,
         setMaxDistance, setDisplayLocation, setPoint, getCanAddToProfile, setBbox, getBbox } from '../../../modules/Filters';
import { getBase, setBase, getSearchType, getMapsApiKey, getIsMobile } from '../../../modules/Settings';
import { getLoading, setLoadingJobsData } from '../../../modules/JobsList';
import { LocationGroupInputSelect } from './LocationGroup';

const mapStateToProps = (state) => {
  const maxDistance = maxDistanceForCountry(getMaxDistance(state), getCountry(state));
  return {
    point: getPoint(state),
    bbox: getBbox(state),
    maxDistance,
    intervals: getIntervals(state),
    base: getBase(state),
    loading: getLoading(state),
    units: DISTANCE_UNITS_MAP[getCountry(state)],
    displayLocation: getDisplayLocation(state),
    searchType: getSearchType(state),
    i18n: getI18n(state),
    mapsApiKey: getMapsApiKey(state),
    isMobile: getIsMobile(state),
    canAddToProfile: getCanAddToProfile(state)
  };
};

const mapDispatchToProps = dispatch => ({
  updateMaxDistance: (evt) => {
    dispatch(setMaxDistance(evt.target.options[evt.target.selectedIndex].value));
    document.querySelector('#search-jobs button[type=submit]').click();
  },
  updateLocation: ({ value, coordinates: point, bbox, location }, currentLocation, push, { pathname, qs }, loading, canClearLocation) => {
    dispatch(setDisplayLocation(value));
    const hasCurrentLocation = Boolean(currentLocation);

    if (hasCurrentLocation) {
      dispatch(setLoadingJobsData());
      dispatch(setBbox(bbox || ''));
      dispatch(setPoint(point || ''));
      dispatch(setBase({
        pathname,
        qs: removeURLParameters(qs, ['excludedLocations'])
      }));

      setTimeout(() => { 
        const searchBtn = document.querySelector('#search-jobs button[type=submit]');
        searchBtn.focus();
        searchBtn.click();
      });
    }

    if (!value && !point && !bbox && !location && canClearLocation) {
      dispatch(setLoadingJobsData());
      dispatch(setPoint(''));
      dispatch(setBbox(''));

      let newUrl = removeCurrentPage(qs);
      newUrl = removeURLParameters(newUrl, ['displayLocation', 'point', 'bbox', 'sort', 'maxdistance', 'locations', 'excludedLocations']);

      if(!loading || canClearLocation) {
        push({
          pathname,
          search: newUrl
        });
      }
    }
  }
});

export const LocationGroup = connect(mapStateToProps, mapDispatchToProps)(LocationGroupInputSelect);


